import { render } from "./InicioComponent.vue?vue&type=template&id=1a94f5d0&scoped=true"
import script from "./InicioComponent.vue?vue&type=script&lang=js"
export * from "./InicioComponent.vue?vue&type=script&lang=js"

import "./InicioComponent.vue?vue&type=style&index=0&id=1a94f5d0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a94f5d0"]])

export default __exports__